import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'budget_subjects',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('budget_subjects_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          code: val.code,
          row,
        };
        this.modalConfig.width = '500px';
        this.modalConfig.title = val.name || '查看';
        this.openModal();
      }
    },
  },
};
